export enum EComboItemType {
  Product = 0,
  CatalogItem = 1,
}
